/**
 * @param {() => void} callback
 */
export function viewTransition(callback) {
    if ('startViewTransition' in document) {
        document.startViewTransition(callback);
        return;
    }

    callback();
}